import AgGridWrapper from '@/app/common/components/ag-grid/AgGridWrapper';
import useDomain from '@/hooks/useDomain';
import ToolsBreadcrumb from '@/app/common/components/ToolsBreadcrumb';
import { historyReportColumnConfig } from '@/app/Report/config/historyReportColumnConfig';
import {
  useGetReportHistoryCountQuery,
  useGetReportHistoryMutation
} from '@/app/Report/api/reportApi';

const Overview = () => {
  const { domain_slug, domain } = useDomain();
  const { data } = useGetReportHistoryCountQuery({
    domain_slug,
    page: 1,
    perPage: 50
  });
  const [getReport] = useGetReportHistoryMutation();
  return (
    <>
      <ToolsBreadcrumb
        parentName="گزارش ردیاب"
        parentUrl={`/eporting/tracker/${domain_slug}/${domain}`}
        childs={[]}
      />
      <AgGridWrapper
        height="746px"
        columns={historyReportColumnConfig}
        total={data?.data?.total}
        additionalData={{
          domain_slug
        }}
        fetchFunction={getReport}
        data={data?.data?.rows}
      />
    </>
  );
};

export default Overview;
